// ================= SHARED TYPES =================

export type Asset = {
  tenantAgentID: string;
  agentName: string;
  osVersion: string;
  installedDate: string;
  lastUpdated: string;
  isAgentActive?: boolean;
  statusMessage?: string;
  tenantGroupId?: string;
  groupName?: string;
  softwareAssetVersion?: string;
  osName?: string;
  osFamily?: string;
  osType?: string;
  osArchitecture?: string;
  installationScope?: string;
};

export interface SoftwareSummary {
  softwareAssetName: string;
  softwareAssetVersion: string;
  latestPackageVersion: string;
  packageIdentifier: string;
  currentPackageVersionDate: string;
  latestPackageVersionDate: string;
  agentCount: number;
  availableVersionCount?: number;
}

export interface BannerCard {
  label: string;
  value: string | number;
  date?: string;
}

export interface PaginationInfo {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
  totalPages: number;
  hasPreviousPage: boolean;
  hasNextPage: boolean;
}

export type OverrideMode = 'Blacklist' | 'Allowlist';

export type VersionGroupedRow = {
  softwareAssetVersion: string;
  endpointCount: number;
  serverCount: number;
};

export type GroupGroupedRow = {
  tenantGroupId: string;
  groupName: string;
  endpointCount: number;
  serverCount: number;
};

export const ITEMS_PER_PAGE = 20;
